const keyMirror = require("keymirror");

export const ResultSettingConstants = keyMirror({
  SET_RESULT_SETTING: undefined
});
